import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { DESK_COMMUNICATION_EVENTS, DESK_COMMUNICATION_STATUSES } from "models";
import { EventInfo } from "modules/AppointmentDetails/components/DeskCommunicationLog/components";
import { formatDate } from "utils/dateHelperFunctions";

import type { TFunction } from "i18next";
import type { DeskCommunication, DeskCommunicationEvent } from "models";

const getEventName = (event: DeskCommunicationEvent, comm: DeskCommunication, t: TFunction) => {
  switch (event.type) {
    case DESK_COMMUNICATION_EVENTS.DeskCheckInSent:
      return t("v8_sent", "Sent");

    case DESK_COMMUNICATION_EVENTS.DeskCheckInReceived:
      return t("v8_received", "Received");

    case DESK_COMMUNICATION_EVENTS.DeskCheckInFailedToOpen:
      return t("v8_failed_to_open", "Failed to open");

    case DESK_COMMUNICATION_EVENTS.DeskCheckInOpened:
      return t("v8_opened", "Opened");

    case DESK_COMMUNICATION_EVENTS.DeskCheckInCanceled:
      return t("v8_canceled", "Canceled");

    case DESK_COMMUNICATION_EVENTS.DeskCheckInAnswered:
      return t("v8_answered", "Answered");

    default:
      if (comm.status === DESK_COMMUNICATION_STATUSES.DeskCheckInClosed) return t("v8_closed", "Closed");
      return "";
  }
};

type CommunicationEventsProps = {
  events?: DeskCommunicationEvent[];
  comm: DeskCommunication;
};

export const CommunicationEvents = ({ events, comm }: CommunicationEventsProps) => {
  const { t } = useTranslation();
  if (!events) return null;

  return (
    <div className="desk-comm-section-container">
      <div className="desk-comm-section-header">{t("v8_communication_events", "Communication events")}</div>

      <Grid>
        {events.map((event, key) => {
          return (
            <Grid.Row key={key} className="section-rows">
              <Grid.Column width={12}>{getEventName(event, comm, t)}</Grid.Column>

              <Grid.Column width={4} className="event-timestamp">
                {formatDate(event.created_on, DATE_FORMATS_FNS.hoursMinutes)} - {formatDate(event.created_on, DATE_FORMATS_FNS.dateMonthYear)}
              </Grid.Column>

              <EventInfo comm={comm} event={event} />
            </Grid.Row>
          );
        })}
      </Grid>
    </div>
  );
};
